
export interface CountryDto {
  name?: string;
  regions: string[];
}
